import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import smoothscroll from 'smoothscroll-polyfill';
import { DragDropContext, Draggable, Droppable } from '@atlaskit/pragmatic-drag-and-drop-react-beautiful-dnd-migration';

import Loader from '../../components/Loader';
import Button from '../../components/Button';
import ApplyCard from '../../components/ApplyCard';
import ScheduleModal from '../schedule/ScheduleModal';
import ExpressedInterestForm from '../schedule/ExpressedInterestForm';
import SchoolEvents from '../../components/SchoolEvents';
import { showPopupContent } from '../../actions/popup';
/* eslint-disable import/no-named-as-default */
import { ApplyDefault, ApplyMobile } from '../../utils/mediaQueries';
import ApplicationDragContainer from '../../components/ApplicationDragContainer';
import Tooltip from '../../components/Tooltip';
import style from './Apply.scss';
import { root as applyAlertsRoot } from '../../components/ApplyAlerts/ApplyAlerts.scss';
import { emptyApplicationListItem } from '../../components/ApplicationDragContainer/ApplicationDragContainer.scss';
import { getSchoolsPrograms } from '../../actions/schools';
import {
  fetchExpressedInterests,
  fetchExpressedInterestsInstruments,
} from '../../actions/scheduling';
import { exportnewApplicationDragDrop } from '../../actions/updateApplicationRank';
import getAlerts from '../../actions/alerts';
import { getSavedProgamSchoolsAutocomplete } from '../../actions/autocomplete';
import { getStudent, getStudentApplications } from '../../actions/student';
import Star from '../../components/icons/Star';
import Lightbox from '../../components/Lightbox';
import { addParameterAndSearch } from '../../actions/addParameter';
import { saveApplication } from '../../actions/saveApplication';
import { saveProgram } from '../../actions/saveProgram';
import { updateApplicationRank, groupUpdateApplicationRank } from '../../actions/updateApplicationRank';
import setPage from '../../actions/pagination';
import messages from '../../locale/messages';
import ApplyAlerts from '../../components/ApplyAlerts';
import SearchNoResults from '../../components/SearchNoResults';
import {
  canApplyToProgram,
  programHasAppointment,
  getSavedProgramCount,
  getUnappliedSavedPrograms,
  elementIsInView,
  customisedIntlFormatMessage
} from '../../utils/helpers';
import CoachmarksApply from '../../coachmarksLocale/apply/apply';
import Coachmarks from '../../components/Coachmarks';
import { withRtl } from '../../components/hoc';
import getItemStyle from './utils';
import { INSTUMENTAL_MUSIC_PROGRAM_CODE } from '../../constants';
import analytics from '../../services/analytics';

const localMessages = defineMessages({
  applyHeader: {
    id: 'apply.Header',
    defaultMessage: `Build {studentName}'s Application`,
    description: 'Main header for apply page',
    values: {
      studentName: 'Your',
    },
  },
  applyHeaderSHS: {
    id: 'apply.HeaderSHS',
    defaultMessage: `Register {studentName} for the SHSAT`,
    description: 'Main header for apply page in SHS applications',
    values: {
      studentName: 'Your',
    },
  },
  applyApplicationButton: {
    id: 'apply.ApplicationButton',
    defaultMessage: 'Your Application',
    description: 'Your application button text',
  },
  applySubHeader: {
    id: 'apply.Subheader',
    defaultMessage: `View "Your Application" to see the programs you have added to your application, or to search for and add any program directly. Drag and drop programs to reorder them. Click on programs in the list to view details in order to make final decisions about how to order your list. Your child will be considered for offers in the order of the programs on their application. Schools cannot see the order of programs on your child’s application. It is important to list programs on your application in your true order of preference. Go to the Help page to learn more about how offers are made. If your child does not get into their first choice, then they will be considered for the next choice. No child will be at a disadvantage for admission to a program by not listing it first on their application.`,
    description: `Subheader for apply page`,
  },
  applyMaxProgramsReachedMessage: {
    id: 'apply.MaxProgramsReachedMessage',
    defaultMessage:
      'Your application is full! If you would like to replace one of your current {maxPrograms} choices with this program, select the program you would like to remove from your application.',
    description: 'Student has reached the max number of programs for an application',
  },
  noSavedProgramsSearch: {
    id: 'apply.noSavedProgramsSearch',
    defaultMessage: `You haven’t added any programs to your favorites! Search for options and click the star to add them to your favorites. Then return here and add them to your application. If you know exactly which programs you’d like to apply to, you can {search} for them directly in the application to your left.`,
    description: 'No favorite programs head',
  },
  noSavedProgramsApplication: {
    id: 'apply.noSavedProgramsApplication',
    defaultMessage: `Or if you know exactly which programs you want to apply to, you can search for them directly from the application list.`,
    description: 'No favorite programs',
  },
  allProgramsSavedParagraphOne: {
    id: 'apply.allProgramsSavedParagraphOne',
    defaultMessage: `You’ve added all your favorite programs to your application! If you’re looking for more programs to apply to, try {searching} and adding some more to your favorites.`,
    description: 'All favorite programs have been added, messaging to tell them what to do next',
  },
  addSavedProgram: {
    id: 'apply.addSavedProgram',
    defaultMessage: `Add program: {savedProgram}, school: {programSchool}`,
    description: 'Add saved program to your application',
  },
  cannotApplySubmissionsClosed: {
    id: 'apply.cannotApplySubmissionsClosed',
    defaultMessage: 'Submissions are closed. Programs cannot be added to your application at this time.',
    description: 'Message when submissions are not open',
  },
  applicationExplanatoryText: {
    id: 'applicationdragcontainer.ExplanatoryText',
    defaultMessage:
      'Drag and drop programs to list them in your order of preference. Once you’re happy with your list, click the "Next" button at the bottom to get ready to submit it.',
    description: 'Explanatory text for applications drag and drop, ordering',
  },
  applicationExplanatoryTextLGA: {
    id: 'applicationdragcontainer.applicationExplanatoryLGA',
    defaultMessage:
      'Drag and drop programs to the list. Once you’re happy with your list, click the "Next" button at the bottom to get ready to submit it.',
    description: 'Explanatory text for LGA applications drag and drop',
  },
  applicationExplanatoryTextSHS: {
    id: 'applicationdragcontainer.ExplanatoryTextSHS',
    defaultMessage:
      'Drag and drop Specialized High School programs here in your order of preference. Click "Next" to finish registration.',
    description: 'Explanatory text for applications drag and drop, ordering, registering for specialized high schools',
  },
  applyNoPrograms: {
    id: 'apply.NoPrograms',
    defaultMessage: 'Please add program choice(s) to your application.',
    description: 'Please add program choice(s) to your application.',
  },
});

const PROGRAMS = 'PROGRAMS';
const APPLICATION = 'APPLICATION';

class Apply extends Component {
  static propTypes = {
    alerts: PropTypes.shape({
      count: PropTypes.number,
      results: PropTypes.arrayOf(
        PropTypes.shape({
          code: PropTypes.string,
        }),
      ),
      alertsLoaded: PropTypes.bool,
    }).isRequired,
    autocomplete: PropTypes.shape({
      savedProgramSchoolsUnapplied: PropTypes.shape({
        autocompleteList: PropTypes.arrayOf(PropTypes.string),
        id: PropTypes.arrayOf(PropTypes.number),
      }),
    }).isRequired,
    optionsDict: PropTypes.shape({}).isRequired,
    parameters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    loading: PropTypes.bool.isRequired,
    schools: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    ).isRequired,
    normalSchools: PropTypes.shape({
      entities: PropTypes.shape({
        school: PropTypes.arrayOf(
          PropTypes.shape({
            getProgram: PropTypes.func,
            programs: PropTypes.shape({
              result: PropTypes.arrayOf(PropTypes.string),
              entities: PropTypes.shape({
                program: PropTypes.string,
              }),
            }),
          }),
        ),
      }),
      result: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    user: PropTypes.shape({
      maxPrograms: PropTypes.number.isRequired,
      isSHS: PropTypes.bool.isRequired,
      isLG: PropTypes.bool.isRequired,
      isGT: PropTypes.bool.isRequired,
      isMS: PropTypes.bool.isRequired,
      isRound2: PropTypes.bool.isRequired,
      applicationId: PropTypes.string.isRequired,
      address: PropTypes.string.isRequired,
      studentApplications: PropTypes.shape(),
      firstName: PropTypes.string.isRequired,
      studentInfo: PropTypes.shape({
        // first_name: PropTypes.string,
      }),
      admissionProcess: PropTypes.string.isRequired,
    }).isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      formatMessage: PropTypes.func,
    }).isRequired,
    isRtl: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    expressedInterests: PropTypes.shape().isRequired,
    expressedInterestsInstruments: PropTypes.shape(),
  };

  static contextTypes = {
    intl: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    normalSchools: null,
    isRtl: false,
  };

  constructor(props) {
    super(props);
    const { user } = props;
    const { maxPrograms } = user;
    this.modalContainerRef = React.createRef();
    this.coachmarksSR = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOneSR),
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarksSRMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOneSR),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarksPK = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwoPK)}${customisedIntlFormatMessage(props.intl,  
          CoachmarksApply.stepOneParagraphThreePK,
        )}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarksPKMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwoPK),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphThreePK),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];

    this.coachmarks3K = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo)}${customisedIntlFormatMessage(props.intl,  
          CoachmarksApply.stepOneParagraphThreePK,
        )}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarks3KMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphThreePK),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];

    this.coachmarks2K = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${props.intl.formatMessage(CoachmarksApply.stepOneParagraphOne)}
        ${props.intl.formatMessage(CoachmarksApply.stepOneParagraphTwo)}${props.intl.formatMessage(
          CoachmarksApply.stepOneParagraphThreePK,
        )}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: props.intl.formatMessage(CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarks2KMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: props.intl.formatMessage(CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: props.intl.formatMessage(CoachmarksApply.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: props.intl.formatMessage(CoachmarksApply.stepOneParagraphThreePK),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: props.intl.formatMessage(CoachmarksApply.stepThreeKindergarten),
      },
    ];

    this.coachmarksHS = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo)}${customisedIntlFormatMessage(props.intl,  
          CoachmarksApply.stepOneParagraphThree,
        )}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThree, {maxPrograms}),
      },
    ];
    this.coachmarksHSMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphThree),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThree),
      },
    ];

    this.coachmarksMS = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo)}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeMiddleSchool),
      },
    ];
    this.coachmarksMSMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepTwoParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeMiddleSchool),
      },
    ];

    this.coachmarksK = [
      {
        element: '[data-coachmark="apply-step-1"]',
        intro: `${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne)}
        ${customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo)}${customisedIntlFormatMessage(props.intl,  
          CoachmarksApply.stepOneParagraphThreeKindergarten,
        )}`,
      },
      {
        element: '[data-coachmark="apply-step-2"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];
    this.coachmarksKMobile = [
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphOne),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphTwo),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepOneParagraphThreeKindergarten),
      },
      {
        element: '[data-coachmark="apply-mobile-step-1"]',
        intro: customisedIntlFormatMessage(props.intl,  CoachmarksApply.stepThreeKindergarten),
      },
    ];

    switch (props.user.admissionProcess) {
      case 'PK':
        this.coachmarks = this.coachmarksPK;
        this.coachmarksMobile = this.coachmarksPKMobile;
        break;
      case 'SR':
        this.coachmarks = this.coachmarksSR;
        this.coachmarksMobile = this.coachmarksSRMobile;
        break;
      case '3K':
        this.coachmarks = this.coachmarks3K;
        this.coachmarksMobile = this.coachmarks3KMobile;
        break;
      case '2K':
        this.coachmarks = this.coachmarks2K;
        this.coachmarksMobile = this.coachmarks2KMobile;
        break;
      case 'K':
        this.coachmarks = this.coachmarksK;
        this.coachmarksMobile = this.coachmarksKMobile;
        break;
      case 'MS':
        this.coachmarks = this.coachmarksMS;
        this.coachmarksMobile = this.coachmarksMSMobile;
        break;
      case 'HS':
        this.coachmarks = this.coachmarksHS;
        this.coachmarksMobile = this.coachmarksHSMobile;
        break;
      default:
        this.coachmarks = null;
        this.coachmarksMobile = null;
    }

    // used to remember which destination was hovered last,
    // so the state is changed only when the first hover is triggered
    this.lastHoverIndex = null;
    this.state = {
      currentSchoolDetail: null,
      currentProgramId: 0,
      applicationLightBox: false,
      // applicationPopUp: false,
      mobileRender: PROGRAMS,
      sortBy: 'savedAt',
      sortByDirection: 'highToLow',
      loaded: false,
      showModal: false,
      showProgramDetailTop: false,
      program: null,
      directoryProgramId: null,
      directorySchoolId: null,
      detailShowsSchool: true,
      isSHS: false,
      isGT: false,
      isMS: false,
      composite: false,
      noPrograms: false,
    };

    this.mobileRenderMapping = {
      PROGRAMS: this.renderPrograms,
      APPLICATION: this.renderApplication,
    };

    smoothscroll.polyfill();
  }

  componentDidMount() {
    const { user, dispatch } = this.props;
    const { applicationId } = user;
    const { loaded } = this.state;
    if (loaded) {
      return;
    }

    const getSchoolsProgramsTask = dispatch(getSchoolsPrograms()).catch(error => {
      console.error('Failed to getSchoolsPrograms', error);
    });
    const getStudentApplicationsTask = dispatch(getStudentApplications(applicationId)).catch(error => {
      console.error('Failed to getStudentApplications', error);
    });

    let tasksList = [
      getSchoolsProgramsTask,
      getStudentApplicationsTask,
    ]
      if (user.admissionProcess === 'LG') {
        const ExpressedInterestTask = dispatch(fetchExpressedInterests(applicationId)).catch(error => {
          console.error('Failed to getStudent', error);
        });
        const FetchExpressedInterestsInstrumentsTask = dispatch(fetchExpressedInterestsInstruments(applicationId)).catch(error => {
          console.error('Failed to getStudent', error);
        });
    
        tasksList.push(ExpressedInterestTask);
        tasksList.push(FetchExpressedInterestsInstrumentsTask);
      }
    Promise.all(tasksList)
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
        });
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  componentDidUpdate(prevProps) {
    const { dispatch, intl, optionsDict } = this.props;
    if (prevProps.intl.locale !== intl.locale) {
      dispatch(getSchoolsPrograms());
    }

    if (prevProps.optionsDict !== optionsDict) {
      dispatch(getSchoolsPrograms());
    }
  }

  // // This could probably be moved somewhere so it becomes re-usable
  // getSchools = () => {
  //   this.props.getSchoolsPrograms();
  // };

  onDragEnd = result => {
    const { source, destination, draggableId } = result;
    if (destination && destination.droppableId == "droppable-0" && source.droppableId != destination.droppableId) {
      this.handleSaveApplication({...JSON.parse(draggableId), destination});
    } else if (destination &&
        destination.droppableId == "droppable-0" &&
        source.droppableId == destination.droppableId &&
        source.index != destination.index) {
      const { results } = this.props.user.studentApplications;
      let programToMove = results.splice(source.index,1)[0];
      results.splice(destination.index, 0, programToMove);
      exportnewApplicationDragDrop(results);
      this.storeProgramRanking();
    }
  };

  setPage = () => {
    const { dispatch } = this.props;
    dispatch(setPage('up'));
    dispatch(getSchoolsPrograms());
  };

  showAutocompleteSchoolDetail = string => {
    const { autocompleteList, id } = this.props.autocomplete.savedProgramSchoolsUnapplied;
    const schoolId = id[autocompleteList.indexOf(string)];
    this.handleSchoolClick(schoolId);
  };

  getReviewUrl = () => {
    const { origin, pathname } = window.location;
    const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
    return new URL('review', `${origin}${normalizedPath}`).toString();
  };

  goToApplicationReview = () => {
    const { dispatch } = this.props;

    return dispatch(getAlerts())
      .then(() => this)
      .then(() => {
        const { alerts } = this.props;

        // Return true if there are deleted programs
        if (alerts.alertsLoaded && alerts.count === 0) {
          window.location.assign(this.getReviewUrl());
          return false;
        }
        document.querySelector(`.${applyAlertsRoot}`).focus();
        for (let i = 0; i < alerts.count; i += 1) {
          if (alerts.results[i].code.includes('DelProg')) {
            return true;
          }
        }
        return false;
      });
  };

  handleAutocompleteBlur = () => {
    const emptyApplicationList = document.querySelector(`.${emptyApplicationListItem}`);
    if (emptyApplicationList) {
      emptyApplicationList.focus();
    }
  };

  backToList = () => {
    this.setState({
      currentSchoolDetail: null,
      currentProgramId: 0,
    });
  };

  handleSchoolClick = (id, event) => {
    // someone just selected the button via keyboard
    if (event && event.type === 'keydown') {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }
      event.stopPropagation();
      event.preventDefault();
    }

    const { currentSchoolDetail, currentProgramId } = this.state;
    if (currentSchoolDetail === id) {
      // CURRENT SCHOOL
      if (currentProgramId) {
        // clicking a school map title AND we have a program open
        this.setState({
          ...this.state,
          currentProgramId: 0,
        });
      } else {
        // clicking the school map title when school card is open and no program is open
        this.setState({
          ...this.state,
          currentSchoolDetail: id,
          currentProgramId: 1,
        });
      }
    } else {
      this.setState({
        ...this.state,
        currentSchoolDetail: id,
        currentProgramId: 0,
      });
    }

    // need to scroll this so the school details are actually visible
    const target = document.querySelector('.backToListScrollTarget');
    if (target && !elementIsInView(target)) {
      const scrollY = window.pageYOffset + target.getBoundingClientRect().bottom;
      // sk - math is as follows
      // 62 = nav bar height
      // 66 = back to button height
      // 20 = padding so the button isn't flush with the nav bar
      window.scrollTo(0, scrollY - (62 + 66 + 20));
    }
  };

  handleProgramClick = (id, schoolId) => {
    const { currentProgramId } = this.state;
    // sk: if we are in school detail
    // all user interactions are intentional
    if (id === currentProgramId) {
      this.setState({
        ...this.state,
        currentProgramId: 1,
      });
    } else {
      this.setState({
        ...this.state,
        currentSchoolDetail: schoolId,
        currentProgramId: id,
      });
    }
  };

  handleShowPopupContent = ({ children, top, left }) => {
    const { dispatch } = this.props;
    dispatch(showPopupContent({ children, top, left }));
  };

  /*
  handleSaveApplicationFromDragContainer = (id, schoolId, savedApplication, savedApplicationId) => {
    const { dispatch } = this.props;
    // Deletes a program from the application. Returns true if api call is successful.
    dispatch(saveApplication(id, schoolId, savedApplication, savedApplicationId)).then(() => {
      if (Response.ok) {
        return true;
      }
      return false;
    });

  };
  */

  storeProgramRanking = () => {
    const { dispatch } = this.props;
    const { results } = this.props.user.studentApplications;
    const { application } = this.props.user.studentApplications.entities;
    const y = results.map((id, index) => ({
      id: application[id].id,
      rank: index + 1,
    }));
    dispatch(groupUpdateApplicationRank(y));
  };

  handleSaveApplication = ({ programId, schoolId, schoolDbn, savedApplication, savedApplicationId, programData, destination }) => {
    const { dispatch, user } = this.props;
    const { results } = user.studentApplications;
    if (results.length < user.maxPrograms || user.maxPrograms == null) {
      if (user.isLG && programData.program.code === INSTUMENTAL_MUSIC_PROGRAM_CODE) {
        var programToBeSaved = { programId, schoolId, savedApplication, savedApplicationId, programData };

        return this.setState({
          program: programData,
          showModal: true,
          programToBeSaved: programToBeSaved
        });


      }
      else {
        dispatch(
          showPopupContent({
            children: 'This program has been added to your application',
          }),
        );

        const rank = destination && typeof destination.index === 'number' ? destination.index + 1 : undefined;
        dispatch(saveApplication(programId, schoolId, schoolDbn, savedApplication, savedApplicationId, programData, rank)).then((status) => {
          if(status == 'ADD_TO_APPLICATION_SUCCESS'){
            this.handleLooProgramAddToApplicationAction(true, programData);
          }
          if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
            this.handleLooProgramAddToApplicationAction(false, programData);
          }
          this.storeProgramRanking();
        });

        return this.setState({
          applicationLightBox: false,
        });
      }
    }

    return this.setState({
      applicationLightBox: true,
      showModal: false,
      replaceSchool: {
        programId,
        schoolId,
      },
    });
  };

  handleUpdateApplicationRank = ({ programId, schoolId, rank, savedApplicationId }) => {
    const { dispatch } = this.props;
    dispatch(updateApplicationRank(programId, schoolId, rank, savedApplicationId));
  };

  close = () => {
    this.setState({ applicationLightBox: false });
  };

  open = () => {
    this.setState({ applicationLightBox: true });
  };

  handleLooProgramAddToApplicationAction = (is_added, programData) => {
    const { program, directory_school_dbn, directory_school_name } = programData;
    const { code, name } = program;
    let dataDictionary = {
      programName: `${name}`,
      programCode: `${code}`,
      schoolName: `${directory_school_name}`,
      schoolDbn: `${directory_school_dbn}`,
      loggedIn: true
    };
    if(this.props.user.show_loo_tooltip){
      const { loo_chances } = programData;
      dataDictionary['looIndicator'] = loo_chances || 'NOT_AVAIL_PROB';
    }
    analytics({
      eventLabel: is_added ? 'programAdded' : 'programRemoved',
      dataDictionary: dataDictionary,
    });
  }

  replaceApplicationProgram = ({ programToBeRemovedId, schoolOfProgramToBeRemovedId }) => {
    const { user, normalSchools, dispatch } = this.props;
    const { entities } = user.studentApplications;
    const { programId, schoolId } = this.state.replaceSchool;
    const program = normalSchools.entities.school[schoolId].getProgram(programId);
    const programDataToBeRemoved = normalSchools.entities.school[schoolOfProgramToBeRemovedId].getProgram(programToBeRemovedId);
    /* eslint-disable-next-line react/prop-types */
    const applicationId = entities.application[programToBeRemovedId].id || entities.application[programToBeRemovedId].directory_program.application_program_id;
    // here we are removing a school _and_ adding (effectively replacing!)
    // we need to include program data when we save, don't care about it when we remove
    dispatch(saveApplication(programToBeRemovedId, schoolOfProgramToBeRemovedId, '', true, applicationId)).then((status) => {
      if(status == 'ADD_TO_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(true, programDataToBeRemoved);
      }
      if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
        this.handleLooProgramAddToApplicationAction(false, programDataToBeRemoved);
      }
      dispatch(saveApplication(programId, schoolId, '', false, '', program)).then((status) => {
        if(status == 'ADD_TO_APPLICATION_SUCCESS'){
          this.handleLooProgramAddToApplicationAction(true, program);
        }
        if(status == 'REMOVE_FROM_APPLICATION_SUCCESS'){
          this.handleLooProgramAddToApplicationAction(false, program);
        }
        this.storeProgramRanking();
      });
      this.close();
    });
  };

  modalContent = () => {
    // data changed from normalSchools to user.studentApplications.entities/results
    const { user } = this.props;
    const { results, entities } = user.studentApplications;
    return results.map(programId => (
      <ApplyCard
        className={style.modalApplyCards}
        key={`${programId}-modal`}
        onClick={() =>
          this.replaceApplicationProgram({
            programToBeRemovedId: programId,
            schoolOfProgramToBeRemovedId: entities.application[programId].directory_program.directory_school_id,
          })
        }
        rank={results.indexOf(programId)}
        id={programId}
        {...entities.application[programId]}
        updateApplicationRank={this.handleUpdateApplicationRank}
        hideButton
        firstName={user.firstName}
        user={user}
      />
    ));
  };

  handleKeyDown = string => {
    const { dispatch } = this.props;
    dispatch(getSavedProgamSchoolsAutocomplete(string));
  };

  handleSaveProgram = (id, schoolId, saved, savedProgramId) => {
    const { dispatch } = this.props;
    return dispatch(saveProgram(id, schoolId, saved, savedProgramId));
  };

  // saveProgramFunc = (id, schoolId, saved, savedProgramId) =>
  //   this.props.saveProgram(id, schoolId, saved, savedProgramId);

  mobileShowPrograms = () => {
    this.setState({ mobileRender: PROGRAMS });
  };

  mobileShowApplication = () => {
    this.setState({ mobileRender: APPLICATION });
  };

  handleSort = ({ sortBy, sortByDirection }) => {
    this.setState({
      ...this.state,
      sortBy,
      sortByDirection,
    });
  };

  handleCheckForAlerts = () => {
    const { dispatch } = this.props;
    dispatch(getAlerts());
  };

  hasNoPrograms = () => {
    const { user } = this.props;
    const programsPresent = user.studentApplications && user.studentApplications.results.length > 0;
    this.setState({
      ...this.state,
      noPrograms: !programsPresent
    });
    return !programsPresent;
  };

  handleLetsContinue = () => {
    const { user, dispatch } = this.props;
    if (user.isMS) {
      return dispatch(getAlerts())
        .then(() => this)
        .then(() => {
          const { alerts } = this.props;

          // Return true if there too many MT programs or not in sync with registered tests
          document.querySelector(`.${applyAlertsRoot}`).focus();
          if (alerts.results.some(e => e.code == "TooManyMPA" || e.code == "LackProgTest" || e.code == "LackTestProg")) {
            return true;
          }
          else {
            if(this.hasNoPrograms()){
              return false
            }else{
              window.location.assign(this.getReviewUrl());
              return false;
            }
          }
        });
    }
    else {
      if(this.hasNoPrograms()){
        return false
      }
      else{
      window.location.assign(this.getReviewUrl());
      return false;
      }
    }
  }

  renderSchools = () => {
    const {
      normalSchools,
      loading,
      user,
      user: { applicationId },
      isRtl,
    } = this.props;
    const { intl } = this.props;
    let load = null;

    if (loading) {
      load = (
        <ul className={style.list}>
          <li className={style.listItem}>
            <Loader />
          </li>
        </ul>
      );
      return load;
    }
    let newResults = normalSchools.result;
    if (user.isSR && normalSchools.result.length) {
      const affiliatedEntity = Object.values(normalSchools.entities.school).find(
        entry => entry.isAffiliatedSRLocation === true
      );
      if (affiliatedEntity) {
        newResults.sort((a, b) => {
          if (a === affiliatedEntity.id) {
            return -1; // Place the affiliatedEntity at the beginning
          } else if (b === affiliatedEntity.id) {
            return 1; // Place the affiliatedEntity at the beginning
          } else {
            return 0; // Maintain the relative order of other elements
          }
        });
      }
    }

    const favoritePrograms = (
      <ul className={style.list}>
        {normalSchools.result.map(schoolID => {
          const {
            url,
            isAffiliatedSRLocation,
            programs: {
              result: programIDs,
              entities: { program: schoolPrograms },
            },
          } = normalSchools.entities.school[schoolID];

          return programIDs.map(programID => {
            const { eligible } = schoolPrograms[programID];
            const programData = normalSchools.entities.school[schoolID].getProgram(programID);
            const canSubmitApplication = user.can_submit;
            const canAddToApplication =
              (canApplyToProgram(programData) || user.isRound2) && eligible && canSubmitApplication;
            let programClasses = [style.school];
            if (isAffiliatedSRLocation) {
              programClasses = [style.affiliatedSchool];
            }
            if (programData.saved) {
              return (
                <li className={style.listApplyItem} key={programID}>
                  <div className={classNames(...programClasses)}>
                    <h4 className={style.schoolName}>
                      <a href={`/dashboard/${applicationId}${url}`} target="_blank" rel="noopener">
                        {schoolPrograms[programID].directory_school_name}
                      </a>
                    </h4>
                    <p className={style.programName}>{schoolPrograms[programID].program.name}</p>

                    {!user.isSR&& (
                      <SchoolEvents
                        page={'apply'}
                        dbn={schoolPrograms[programID].directory_school_dbn}
                      />
                    )}

                  </div>
                  <div className={style.button}>
                    {canAddToApplication ? (
                      schoolPrograms[programID].savedApplication ? (
                        <Button
                          ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                            savedProgram: programData.name,
                            programSchool: programData.directory_school_name,
                          })}
                          label="Added!"
                          attachLeft={!isRtl}
                          attachRight={isRtl}
                          iconTop="Check"
                          customClass={style.addedButton}
                          iconColor="#052b52"
                          disabled
                        />
                      ) : (
                        <Button
                          ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                            savedProgram: programData.name,
                            programSchool: programData.directory_school_name,
                          })}
                          label={customisedIntlFormatMessage(intl, messages.buttonAdd)}
                          onClick={() =>
                            this.handleSaveApplication({
                              programId: programID,
                              schoolId: schoolID,
                              savedApplication: false,
                              savedApplicationId: '',
                              programData,
                            })
                          }
                          attachLeft={!isRtl}
                          attachRight={isRtl}
                          iconTop="Plus"
                        />
                      )
                    ) : (
                      <div className={style.tooltipContainer}>
                        <Tooltip
                          icon={<i className="icon-Alert" />}
                          left={-250}
                          width="250px"
                          top="50%"
                          ariaLabel={customisedIntlFormatMessage(intl, messages.generalStringStudentNotEligible, {
                            firstName: user.firstName,
                          })}
                        >
                          {!canSubmitApplication && <FormattedMessage {...localMessages.cannotApplySubmissionsClosed} />}
                          {!eligible && canSubmitApplication && (
                            <p>
                              <FormattedMessage
                                {...messages.generalStringStudentNotEligible}
                                values={{
                                  firstName: user.firstName,
                                }}
                              />
                              <br />
                              <i>
                                <FormattedMessage {...messages.generalStringStudentNotEligibleHelp} />
                              </i>
                            </p>
                          )}
                          {eligible && !canApplyToProgram(programData) && canSubmitApplication && (
                            <FormattedMessage {...messages.generalStringProgramNeedsAssessment} />
                          )}
                          {programHasAppointment(programData.scheduling) && (
                            <FormattedMessage {...messages.generalStringProgramHasAppointment} />
                          )}
                        </Tooltip>
                      </div>
                    )}
                  </div>
                </li>
              );
            }
            return null;
          });
        })}
      </ul>
    );
    return (
      <div>
        {favoritePrograms}
        {load}
      </div>
    );
  };

  renderMobileButtons = () => {
    const { intl } = this.props;
    const { mobileRender } = this.state;
    const programClasses = ['button--no-style', style.programsButton];
    const applicationClasses = ['button--no-style', style.applicationButton];

    if (mobileRender === PROGRAMS) {
      programClasses.push(style.mainButtonActive);
    } else if (mobileRender === APPLICATION) {
      applicationClasses.push(style.mainButtonActive);
    }
    return (
      <ApplyMobile>
        <div className={style.mainButtons} data-coachmark="apply-mobile-step-1">
          <button
            className={classNames(...programClasses)}
            aria-label={customisedIntlFormatMessage(intl, messages.generalStringSavedPrograms)}
            onClick={this.mobileShowPrograms}
          >
            <i className="icon-Star" /> <FormattedMessage {...messages.generalStringSavedPrograms} />
          </button>
          <button
            className={classNames(...applicationClasses)}
            aria-label={customisedIntlFormatMessage(intl, localMessages.applyApplicationButton)}
            onClick={this.mobileShowApplication}
          >
            <i className="icon-Time" /> <FormattedMessage {...localMessages.applyApplicationButton} />
          </button>
        </div>
      </ApplyMobile>
    );
  };

  renderPrograms = () => {
    const { normalSchools, user, schools } = this.props;
    const { applicationId } = user;
    const { currentSchoolDetail, loaded } = this.state;
    const path = `/dashboard/${applicationId}/schools/`;
    const searchingLink = <a href={path}>search</a>;
    // all saved programs regardless of saved applications
    const savedProgramCount = getSavedProgramCount(schools);
    // only saved programs without a saved application
    const unappliedSavedProgramsCount = getUnappliedSavedPrograms({ normalSchools }).length;
    const displayNoSavedProgramsMessage = loaded && savedProgramCount === 0;
    const displayNoSearchResults = loaded && savedProgramCount > 0 && normalSchools.result.length === 0;

    return (
      <div className={style.applicationWrapper}>
        <div>
          <ApplyMobile>
            <div className={style.sidebarHeader} data-coachmark="apply-step-1">
              <Star fill="#4EE4B3" size="32px" />
              <FormattedMessage {...messages.generalStringSavedPrograms} tagName="h2" />
            </div>
            {displayNoSavedProgramsMessage && (
              <div className={style.subHeader}>
                <div className={style.mb20}>
                  <FormattedMessage
                    {...localMessages.noSavedProgramsSearch}
                    values={{
                      search: searchingLink,
                    }}
                  />
                </div>
                <div className={style.mb20}>
                  <FormattedMessage {...localMessages.noSavedProgramsApplication} />
                </div>
              </div>
            )}
          </ApplyMobile>
          <div className={style.schools}>
            {displayNoSearchResults && !displayNoSavedProgramsMessage && !currentSchoolDetail && <SearchNoResults />}
            {!displayNoSearchResults && unappliedSavedProgramsCount === 0 && !displayNoSavedProgramsMessage && (
              <div className={style.subHeader}>
                <p>
                  <FormattedMessage
                    {...localMessages.allProgramsSavedParagraphOne}
                    values={{
                      search: searchingLink,
                    }}
                  />
                </p>
                <p>
                  <FormattedMessage {...localMessages.noSavedProgramsApplication} />
                </p>
              </div>
            )}
            {this.renderSchools()}
          </div>
        </div>
      </div>
    );
  };

  renderApplication = () => {
    // const { user, showPopupContent, saveApplication } = this.props;
    const { user, autocomplete } = this.props;
    const canSubmitApplication = user.can_submit;
    const submitDisabledMessage = user.disabled_submit_reason;

    return (
      <div className={style.sidebar}>
        {user.isSHS ? (
          <FormattedMessage
            {...localMessages.applyHeaderSHS}
            values={{
              studentName: user.firstName,
            }}
            tagName="h1"
          />
        ) : (
          <FormattedMessage
            {...localMessages.applyHeader}
            values={{
              studentName: user.firstName,
            }}
            tagName="h1"
          />
        )}
        <div className={style.subHeaderWhite}>
          {user.isLG ? (
            <FormattedMessage {...localMessages.applicationExplanatoryTextLGA} />
          ) :
            user.isSHS ? (
              <FormattedMessage {...localMessages.applicationExplanatoryTextSHS} />
            ) : (
              <FormattedMessage {...localMessages.applicationExplanatoryText} />
            )}
        </div>
        <ApplicationDragContainer
          updateApplicationRank={this.handleUpdateApplicationRank}
          showPopupContent={this.handleShowPopupContent}
          autocomplete={autocomplete}
          normalSchools={this.props.normalSchools}
          handleProgramClick={this.handleProgramClick}
          saveProgramFunc={this.handleSaveProgram}
          canSubmitApplication={canSubmitApplication}
          submitDisabledMessage={submitDisabledMessage}
          goToApplicationReview={this.goToApplicationReview}
          onAutocompleteBlur={this.handleAutocompleteBlur}
          storeProgramRanking={this.storeProgramRanking}
        />
      </div>
    );
  };

  closeExpressedInterestModal = () => {
    this.setState({ showModal: false });
  };

  interestSaved = () => {
    this.setState({ interestSaved: true });
  }

  onAfterModalClose = () => {
    this.setState({ showModal: false });
  };

  focusModal = () => {
    this.modalContainerRef.current.focus();
  };

  renderModal = () => {
    const { user, intl } = this.props;
    const { showModal, programToBeSaved, program } = this.state;

    let modalContent;
    let modalAriaLabel;
    let { closeModal } = this;
    if (program) {

      closeModal = this.closeExpressedInterestModal;
      modalContent = (
        <ExpressedInterestForm
          user={user}
          program={program}
          applicationId={user.applicationId}
          reset={this.closeExpressedInterestModal}
          isSHS={user.isSHS}
          isGT={user.isGT}
          isMS={user.isMS}
          isLG={user.isLG}
          expressedInterests={this.props.expressedInterests}
          expressedInterestsInstruments={this.props.expressedInterestsInstruments}
          interestSaved={this.interestSaved}
          programToBeSaved={programToBeSaved}
        />
      );
      modalAriaLabel = customisedIntlFormatMessage(intl, messages.buttonExpressInterest);

    }

    return (
      <ScheduleModal
        show={showModal}
        close={closeModal}
        afterClose={this.onAfterModalClose}
        ariaLabel={modalAriaLabel}
        containerRef={this.modalContainerRef}
        focusModal={this.focusModal}
      >
        {modalContent}
      </ScheduleModal>
    );
  };

  render() {
    // replace the applicationLightbox to be present here instead of
    // in `renderApplication` so it's visible on mobile
    // const { mobileRender, applicationLightBox, replaceSchool, loaded, currentSchoolDetail } = this.state;
    const { mobileRender, applicationLightBox, replaceSchool, loaded, currentSchoolDetail, showModal } = this.state;
    const { autocomplete, normalSchools, alerts, user, intl, isRtl, schools } = this.props;
    const { count, results } = alerts;
    const { applicationId, maxPrograms } = user;
    const canSubmitApplication = user.can_submit;
    const submitDisabledMessage = user.disabled_submit_reason;
    const path = `/dashboard/${applicationId}/schools/`;
    const searchingLink = <a href={path}>search</a>;
    // all saved programs regardless of saved applications
    const savedProgramCount = getSavedProgramCount(schools);
    // only saved programs without a saved application
    const unappliedSavedProgramsCount = getUnappliedSavedPrograms({ normalSchools }).length;
    const displayNoSavedProgramsMessage = loaded && savedProgramCount === 0;
    const displayNoSearchResults = loaded && savedProgramCount > 0 && normalSchools.result.length === 0;
    let disableWithAlerts = results.some(e => e.code == "TooManyMPA" || e.code == "LackProgTest" || e.code == "LackTestProg");
    if (!loaded) {
      return <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />;
    }

    return (
      <main className={style.root} role="presentation">
        <div className={style.wrapper}>
          <div className={style.container}>
            <div className={style.header} />
            {this.renderMobileButtons()}
            <div className="alertsScrollTarget" />

            {this.state.noPrograms && <div className={style.alertBox}><span><FormattedMessage {...localMessages.applyNoPrograms} /></span></div>}

            <div className={style.flex} aria-live="assertive">
              {count > 0 &&  <ApplyAlerts count={count} disableContinueWithAlerts={disableWithAlerts} alerts={results} onCheckForAlerts={this.handleCheckForAlerts} onLetsContinue={this.handleLetsContinue} />}
            </div>
            <div className={style.main}>
              <ApplyMobile>{this.mobileRenderMapping[mobileRender]()}</ApplyMobile>
                <ApplyDefault>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                  <div className={style.sidebar}>
                    {user.isSHS ? (
                      <FormattedMessage
                        {...localMessages.applyHeaderSHS}
                        values={{
                          studentName: user.firstName,
                        }}
                        tagName="h1"
                      />
                    ) : (
                      <FormattedMessage
                        {...localMessages.applyHeader}
                        values={{
                          studentName: user.firstName,
                        }}
                        tagName="h1"
                      />
                    )}
                    <div className={style.subHeaderWhite}>
                      {user.isSHS ? (
                        <FormattedMessage {...localMessages.applicationExplanatoryTextSHS} />
                      ) : user.isLG ? (
                        <FormattedMessage {...localMessages.applicationExplanatoryTextLGA} />
                      ) : (<FormattedMessage {...localMessages.applicationExplanatoryText} />)}
                    </div>
                    <ApplicationDragContainer
                      updateApplicationRank={this.handleUpdateApplicationRank}
                      showPopupContent={this.handleShowPopupContent}
                      autocomplete={autocomplete}
                      normalSchools={this.props.normalSchools}
                      handleProgramClick={this.handleProgramClick}
                      saveProgramFunc={this.handleSaveProgram}
                      canSubmitApplication={canSubmitApplication}
                      submitDisabledMessage={submitDisabledMessage}
                      goToApplicationReview={this.goToApplicationReview}
                      onAutocompleteBlur={this.handleAutocompleteBlur}
                      storeProgramRanking={this.storeProgramRanking}
                    />
                  </div>
                  <div className={style.applicationWrapper}>
                    <div>
                      <ApplyDefault>
                        <div className={style.sidebarHeader} data-coachmark="apply-step-1">
                          <Star fill="#4EE4B3" size="32px" />
                          <FormattedMessage {...messages.generalStringSavedPrograms} tagName="h2" />
                        </div>
                        {displayNoSavedProgramsMessage && (
                          <div className={style.subHeader}>
                            <p>
                              <FormattedMessage
                                {...localMessages.noSavedProgramsSearch}
                                values={{
                                  search: searchingLink,
                                }}
                              />
                            </p>
                            <p>
                              <FormattedMessage {...localMessages.noSavedProgramsApplication} />
                            </p>
                          </div>
                        )}
                      </ApplyDefault>
                      <div className={style.schools}>
                        {displayNoSearchResults && !displayNoSavedProgramsMessage && !currentSchoolDetail && (
                          <SearchNoResults />
                        )}
                        {!displayNoSearchResults &&
                          unappliedSavedProgramsCount === 0 &&
                          !displayNoSavedProgramsMessage && (
                            <div className={style.subHeader}>
                              <p>
                                <FormattedMessage
                                  {...localMessages.allProgramsSavedParagraphOne}
                                  values={{
                                    searching: searchingLink,
                                  }}
                                />
                              </p>
                              <p>
                                <FormattedMessage {...localMessages.noSavedProgramsApplication} />
                              </p>
                            </div>
                          )}
                        <Droppable droppableId="droppable-1" type="PROGRAM" isDropDisabled={false} isCombineEnabled={false} ignoreContainerClipping={false}>
                          {provided => (
                            <div className={style.list} ref={provided.innerRef} {...provided.droppableProps}>
                              {provided.placeholder}
                              {normalSchools.result.map((schoolID, index) => {
                                const {
                                  result: programIDs,
                                  entities: { program: schoolPrograms },
                                } = normalSchools.entities.school[schoolID].programs;
                                const isAffiliatedSRLocation = normalSchools.entities.school[schoolID].isAffiliatedSRLocation;
                                return programIDs.map(programID => {
                                  const { eligible } = schoolPrograms[programID];
                                  const programData = normalSchools.entities.school[schoolID].getProgram(programID);

                                  const canAddToApplication =
                                    (canApplyToProgram(programData) || user.isRound2) &&
                                    eligible &&
                                    canSubmitApplication;
                                  let programClasses = [style.school];
                                  if (isAffiliatedSRLocation) {
                                    programClasses = [style.affiliatedSchool];
                                  }
                                  if (programData.saved) {
                                    return (
                                      <Draggable
                                        key={programID}
                                        draggableId={JSON.stringify({
                                          programId: programID,
                                          schoolId: schoolID,
                                          savedApplication: false,
                                          savedApplicationId: '',
                                          programData,
                                        })}
                                        index={index}
                                        type="PROGRAM"
                                        isDragDisabled={schoolPrograms[programID].savedApplication || !eligible || !canSubmitApplication}
                                      >
                                        {(provided, snapshot) => (
                                          <div
                                            className={style.listApplyItem}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                          >
                                            <div className={classNames(...programClasses)}>
                                              <h4 className={style.schoolName}>
                                                <a
                                                  href={`/dashboard/${applicationId}/schools/${schoolID}`}
                                                  target="_blank"
                                                  rel="noopener"
                                                >
                                                  {schoolPrograms[programID].directory_school_name}
                                                </a>
                                              </h4>
                                              <p className={style.programName}>
                                                {schoolPrograms[programID].program.name}
                                              </p>
                                              {!user.isSR && (
                                                <SchoolEvents
                                                  page={'apply'}
                                                  dbn={schoolPrograms[programID].directory_school_dbn}
                                                />
                                              )}
                                            </div>
                                            <div className={style.button}>
                                              {canAddToApplication ? (
                                                schoolPrograms[programID].savedApplication ? (
                                                  <Button
                                                    ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                                                      savedProgram: programData.name,
                                                      programSchool: programData.directory_school_name,
                                                    })}
                                                    label="Added!"
                                                    attachLeft={!isRtl}
                                                    attachRight={isRtl}
                                                    iconTop="Check"
                                                    customClass={style.addedButton}
                                                    iconColor="#052b52"
                                                    disabled
                                                  />
                                                ) : (
                                                  <Button
                                                    ariaLabel={customisedIntlFormatMessage(intl, localMessages.addSavedProgram, {
                                                      savedProgram: programData.name,
                                                      programSchool: programData.directory_school_name,
                                                    })}
                                                    label={customisedIntlFormatMessage(intl, messages.buttonAdd)}
                                                    onClick={() =>
                                                      this.handleSaveApplication({
                                                        programId: programID,
                                                        schoolId: schoolID,
                                                        savedApplication: false,
                                                        savedApplicationId: '',
                                                        programData,
                                                      })
                                                    }
                                                    attachLeft={!isRtl}
                                                    attachRight={isRtl}
                                                    iconTop="Plus"
                                                  />
                                                )
                                              ) : (
                                                <div className={style.tooltipContainer}>
                                                  <Tooltip
                                                    icon={<i className="icon-Alert" />}
                                                    left={-250}
                                                    width="250px"
                                                    top="50%"
                                                    ariaLabel={customisedIntlFormatMessage(intl, 
                                                      messages.generalStringStudentNotEligible,
                                                      {
                                                        firstName: user.firstName,
                                                      },
                                                    )}
                                                  >
                                                    {!canSubmitApplication && (
                                                      <FormattedMessage
                                                        {...localMessages.cannotApplySubmissionsClosed}
                                                      />
                                                    )}
                                                    {!eligible && canSubmitApplication && (
                                                      <p>
                                                        <FormattedMessage
                                                          {...messages.generalStringStudentNotEligible}
                                                          values={{
                                                            firstName: user.firstName,
                                                          }}
                                                        />
                                                        <br />
                                                        <i>
                                                          <FormattedMessage
                                                            {...messages.generalStringStudentNotEligibleHelp}
                                                          />
                                                        </i>
                                                      </p>
                                                    )}
                                                    {eligible &&
                                                      !canApplyToProgram(programData) &&
                                                      canSubmitApplication && (
                                                        <FormattedMessage
                                                          {...messages.generalStringProgramNeedsAssessment}
                                                        />
                                                      )}
                                                    {programHasAppointment(programData.scheduling) && (
                                                      <FormattedMessage
                                                        {...messages.generalStringProgramHasAppointment}
                                                      />
                                                    )}
                                                  </Tooltip>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </Draggable>
                                    );
                                  }
                                  return null;
                                });
                              })}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    </div>
                  </div>
                  </DragDropContext>
                  </ApplyDefault>
            </div>
          </div>
        </div>
        {showModal && this.renderModal()}
        {applicationLightBox && (
          <Lightbox open={this.open} close={this.close} showModal={applicationLightBox}>
            <div>
              <span className={style.helpText}>

                <FormattedMessage 
                  {...localMessages.applyMaxProgramsReachedMessage}
                  values={{ maxPrograms }}
                />
              </span>
              <div className={style.modalApplyCards}>{this.modalContent()}</div>
              <div className={style.replaceProgram}>
                <h6>Replace Selected with program below</h6>
                <ApplyCard
                  key={`${replaceSchool.programId}-modal`}
                  rank={12}
                  directory_program={normalSchools.entities.school[replaceSchool.schoolId].getProgram(
                    replaceSchool.programId,
                  )}
                  id={replaceSchool.programId}
                  hideButton
                  firstName={user.firstName}
                  user={user}
                />
              </div>
            </div>
          </Lightbox>
        )}
        {loaded && this.coachmarks && this.coachmarksMobile && (
          <div>
            <ApplyDefault>
              <Coachmarks steps={this.coachmarks} context="apply" />
            </ApplyDefault>
            <ApplyMobile>
              <Coachmarks steps={this.coachmarksMobile} context="apply" />
            </ApplyMobile>
          </div>
        )}
      </main>
    );
  }
}

// const mapStateToProps = ({ schools, schoolsApplications, filters, user, alerts }) => ({
const mapStateToProps = ({ schools, schoolsApplications, user, alerts, expressedInterests }) => ({
  ...schools,
  schoolsApplications,
  user,
  alerts,
  expressedInterests,
});

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(Apply);
